import { fabric } from "fabric"

export default class PatternObject extends fabric.Pattern {
  svgScale: number
  svgUrl: string

  toSVG() {
    const scale = Math.max(this.svgScale, 0.1)
    const patternImgSrc = this.svgUrl

    return (
      '<pattern id="SVGID_' +
      this.id +
      '" ' +
      ' x="0"' +
      ' y="0"' +
      ' viewBox="0 0 1 1"' +
      ' preserveAspectRatio="xMidYMid slice"' +
      ' patternContentUnits="objectBoundingBox"' +
      ' width="' +
      100 / scale +
      '%"' +
      ' height="' +
      100 / scale +
      '%">\n' +
      '<image x="0" y="0"' +
      ' width="1"' +
      ' height="1"' +
      ' preserveAspectRatio="xMidYMid slice"' +
      ' xlink:href="' +
      patternImgSrc +
      '"' +
      "></image>\n" +
      "</pattern>\n"
    )
  }
}
